export default __webpack_public_path__ + "static/media/orcking-worn.91ff6074.jpg";